import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, Notification } from '../../services/notification.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-notification-panel',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './notification-panel.html',
    styleUrl: './notification-panel.scss'
})
export class NotificationPanelComponent implements OnInit {
    notifications$: Observable<Notification[]>;
    isOpen$: Observable<boolean>;

    constructor(private notificationService: NotificationService) {
        this.notifications$ = this.notificationService.notifications$;
        this.isOpen$ = this.notificationService.isOpen$;
    }

    ngOnInit(): void { }

    close(): void {
        this.notificationService.close();
    }

    markAsRead(id: string): void {
        this.notificationService.markAsRead(id);
    }

    getAvatarBackground(avatar: string): string {
        if (avatar === 'M') return 'linear-gradient(135deg, #FF9966 0%, #FF5E62 100%)';
        if (avatar === 'B') return '#7D7D7D';
        return '#F5F5F5';
    }
}
